"use client";

import TravellersRequiredInformationComponent from "@/app/components/travellers-required-information";
import { TravellersRequiredInformationProvider } from "@/app/components/travellers-required-information/provider/travellers-required-information.provider";

export default function RequiredInformationPageClient({
  pageContent,
}: Readonly<{
  pageContent: unknown;
}>) {
  return (
    <TravellersRequiredInformationProvider magnoliaData={pageContent as any}>
      <TravellersRequiredInformationComponent />
    </TravellersRequiredInformationProvider>
  );
}
